export default __webpack_public_path__ + "images/EI.d6a15b1.png";